import { FC, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDrawerFilters } from '@minecraft.drawer';
import { FilterValues } from '../../../shared/types';

type Props = {
  onRetainedFiltersChange: (newFilters: FilterValues) => void;
};

const FilterBasicFormListener: FC<Props> = ({ onRetainedFiltersChange }) => {
  const { values } = useFormikContext();
  const { handleDrawerRateinedFiltersChange } = useDrawerFilters();

  useEffect(() => {
    onRetainedFiltersChange(values);
    handleDrawerRateinedFiltersChange(values);
  }, [values]);

  return null;
};

export default FilterBasicFormListener;
